import { render, staticRenderFns } from "./preview-image-viewer.vue?vue&type=template&id=8487b1e8"
import script from "./preview-image-viewer.vue?vue&type=script&lang=ts"
export * from "./preview-image-viewer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports